export default __webpack_public_path__ + "static/artifakt-element-italic-9f090bbb747ae32ddbf0a110eab0eb97.woff";